<nav class="mobile-nav">
    <button
        tuiButton
        shape="square"
        size="m"
        (click)="toggleMobileMenu(true)"
        (tuiActiveZoneChange)="toggleMobileMenu($event)"
    >
        <tui-icon icon="@tui.menu" class="hamburger-icon"></tui-icon>

        <div *tuiSidebar="mobileMenuOpen; direction: 'right'" class="mobile-nav-sidebar">
            <a
                routerLink=""
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                tuiTitle
                (click)="toggleMobileMenu(false)"
                ><tui-icon icon="@tui.arrow-big-left" />Dashboard</a
            >
            <a routerLink="flags" routerLinkActive="active" tuiTitle (click)="toggleMobileMenu(false)"
                ><tui-icon icon="@tui.flag" />Feature Flags</a
            >
            @if (isOwner$()) {
                <a routerLink="settings" routerLinkActive="active" tuiTitle (click)="toggleMobileMenu(false)"
                    ><tui-icon icon="@tui.settings" />Project Settings</a
                >
                <a routerLink="members" routerLinkActive="active" tuiTitle (click)="toggleMobileMenu(false)"
                    ><tui-icon icon="@tui.users" />Members</a
                >
                @if (showHistory) {
                    <a routerLink="history" routerLinkActive="active" tuiTitle (click)="toggleMobileMenu(false)"
                        ><tui-icon icon="@tui.history" />History</a
                    >
                }
            } @else if (!projectSettingsLoading$()) {
                <div tuiTitle (click)="exitProjectConfirmation()" class="menu-button">
                    <tui-icon icon="door-open" />
                    Leave Project
                </div>
            }
            <a routerLink="setup" routerLinkActive="active" tuiTitle (click)="toggleMobileMenu(false)"
                ><tui-icon icon="@tui.file-cog" />How To Setup</a
            >
            <div tuiTitle>
                <tui-icon icon="sun-moon" />
                Dark Mode
                <input
                    (click)="toggleDarkMode()"
                    class="theme-switch"
                    tuiSwitch
                    type="checkbox"
                    size="m"
                    [showIcons]="false"
                    [ngModel]="isDarkMode"
                />
            </div>
            <ffx-logout size="m"></ffx-logout>
        </div>
    </button>
</nav>
@if (leaveProjectLoading$()) {
    <div class="full-screen-loader">
        <tui-loader size="xxl" />
    </div>
}
